// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormWrapper_formWrapper__YaVqZ","formContainer":"FormWrapper_formContainer__jY8Kr"};